export class Action {
  static Type = Object.freeze({
    NONE: Symbol("none"),
    CURSOR: Symbol("cursor"),
    SELECT: Symbol("select"),
    PUT: Symbol("put"),
    UNPUT: Symbol("unput"),
    SWIPE_LEFT: Symbol("swipe-left"),
    SWIPE_RIGHT: Symbol("swipe-right"),
    WHEEL: Symbol("wheel"),
  });

  constructor(type, point=null) {
    this.type = type;
    this.point = point;
  }
}

export default class {
  constructor(grid, pxStart, pxSpacing) {
    this.grid = grid;
    this.pxStart = pxStart;
    this.pxSpacing = pxSpacing;

    this.touch = null;
  }

  handle(e, handleAction) {
    let action = null;

    switch(e.type) {
      case 'mousemove':
        action = this.#onMouseMove(e);
        break;
      case 'mousewheel':
        action = this.#onMouseWheel(e);
        break;
      case 'mouseout':
        action = this.#onMouseOut(e);
        break;
      case 'click':
        action = this.#onMouseClick(e);
        break;
      case 'contextmenu':
        action = this.#onMouseRightClick(e);
        break;
      case 'touchstart':
        action = this.#onTouchStart(e);
        break;
      case 'touchmove':
        action = this.#onTouchMove(e);
        break;
      case 'touchend':
        action = this.#onTouchEnd(e);
        break;
      default:
        console.log(`ERROR: unknown event type: ${e.type}`);
    }

    if(action)
      handleAction(action);
  }

  #onMouseMove(e) {
    this.touch = null;
    return this.#action(Action.Type.CURSOR, e.offsetX, e.offsetY);
  }

  #onMouseWheel(e) {
    function sign(val) { return val > 0 ? 1 : (val < 0 ? -1 : 0); }
    return new Action(Action.Type.WHEEL, { x: sign(e.deltaX), y: sign(e.deltaY) });
  }

  #onMouseOut() {
    return this.#action(Action.Type.CURSOR);
  }

  #onMouseClick(e) {
    return this.#action(Action.Type.PUT, e.offsetX, e.offsetY);
  }

  #onMouseRightClick(e) {
    return this.#action(Action.Type.UNPUT, e.offsetX, e.offsetY);
  }

  #onTouchStart(e) {
    this.touch = { origin: e, last: e, current: e };
    return null;
  }

  #onTouchMove(e) {
    if(!this.touch) return null;

    this.touch.last = this.touch.current;
    this.touch.current = e;

    const { x, y } = this.#getTouchCoords();
    return this.#action(Action.Type.CURSOR, x, y);
  }

  #onTouchEnd(e) {
    if(!this.touch) return null;

    const c1 = this.touch.origin.targetTouches[0];
    const c2 = this.touch.current.targetTouches[0];
    const d = Math.abs(c1.clientX - c2.clientX);
    const t = e.timeStamp - this.touch.origin.timeStamp;
    const { x, y } = this.#getTouchCoords();
    this.touch = null;

    if(d > 7 && t < 180)
      return this.#action(c1.clientX > c2.clientX ? Action.Type.SWIPE_LEFT : Action.Type.SWIPE_RIGHT)
    else
      return this.#action(Action.Type.PUT, x, y);
  }

  #getTouchCoords() {
    const d = this.#distance(this.touch.last.targetTouches[0], this.touch.current.targetTouches[0]);
    if(!this.touch.dSum) this.touch.dSum = 0;
    this.touch.dSum += d;

    const K = 0.5;
    const MAX = 80;
    let offset = this.touch.dSum * K;
    if(offset > MAX) offset = MAX;

    const rect = this.touch.origin.target.getBoundingClientRect();
    const t = this.touch.current.targetTouches[0];
    return { x: t.clientX - rect.x, y: t.clientY - offset - rect.y};
  }

  #distance(c1, c2) {
    const dx = c1.clientX - c2.clientX;
    const dy = c1.clientY - c2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  #isSwipingLeft(c1, c2) {
    return c1.clientX - c2.clientX > 5;
  }

  #isSwipingRight(c1, c2) {
    return c2.clientX - c1.clientX > 5;
  }

  #action(type, x=null, y=null) {
    let point = null;
    if(x !== null && y !== null)
      point = this.#getPoint(x, y);

    return new Action(type, point);
  }

  #getPoint(mx, my) {
    const x = Math.round((mx - this.pxStart) / this.pxSpacing);
    const y = Math.round((my - this.pxStart) / this.pxSpacing);

    if(x >= 0 && x < this.grid && y >= 0 && y < this.grid)
      return { x, y };
    else
      return null;
  }
}
